// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"7315f0b0","857":"eafd3e9e"}[chunkId] + ".js";
};